const getAttributionCategory = () => "wishlists";

export default getAttributionCategory;
